import React, { useState } from 'react';
import {
  Box,
  Fab,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  IconButton,
  Card,
  CardContent,
} from '@mui/material';
import { styled } from '@mui/material/styles';

// Professional SVG Icons
const WhatsAppIcon = () => (
  <svg viewBox="0 0 24 24" width="24" height="24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
);

const SupportAgentIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
    <path d="M21 9s-1-2-4-2c-1.5 0-3 .5-3 2s1 2 4 2 4-2 4-2zm-9 0s-1-2-4-2-4 2-4 2 1 2 4 2 4-2 4-2zm9 4s-1-2-4-2-4 2-4 2 1 2 4 2 4-2 4-2zm-9 0s-1-2-4-2-4 2-4 2 1 2 4 2 4-2 4-2z"/>
    <path d="M21 14s-1 2-4 2-4-2-4-2v4h8v-4z"/>
    <path d="M12 14s-1 2-4 2-4-2-4-2v4h8v-4z"/>
  </svg>
);

const AccountBalanceIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
    <path d="M4 10h3v7H4zM10.5 10h3v7h-3zM17 10h3v7h-3zM2 19h20v3H2z"/>
    <path d="M12 2L2 7v2h20V7z"/>
  </svg>
);

const BusinessIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
    <path d="M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z"/>
  </svg>
);

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="currentColor">
    <path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/>
  </svg>
);

const FloatingButton = styled(Fab)(({ theme }) => ({
  position: 'fixed',
  bottom: theme.spacing(3),
  right: theme.spacing(3),
  backgroundColor: '#25D366',
  color: 'white',
  '&:hover': {
    backgroundColor: '#128C7E',
    transform: 'scale(1.1)',
    boxShadow: '0 8px 30px rgba(37, 211, 102, 0.4)',
  },
  transition: 'all 0.3s ease',
  zIndex: 1000,
  boxShadow: '0 4px 20px rgba(37, 211, 102, 0.3)',
  '& .MuiFab-label': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}));

const WhatsAppWidget = () => {
  const [open, setOpen] = useState(false);

  // Update with your actual WhatsApp number
  const whatsappNumber = '+27720100332'; // Replace with your number

  const departments = [
    {
      name: 'General Support',
      number: whatsappNumber,
      icon: <SupportAgentIcon />,
      description: 'For general inquiries and support',
    },
    {
      name: 'Corporate Services',
      number: whatsappNumber,
      icon: <BusinessIcon />,
      description: 'Corporate partnerships and services',
    },
    {
      name: 'Investment Banking',
      number: whatsappNumber,
      icon: <AccountBalanceIcon />,
      description: 'Investment and wealth management',
    },
    {
      name: 'Client Relations',
      number: whatsappNumber,
      icon: <PhoneIcon />,
      description: 'Client support and relations',
    },
  ];

  const handleWhatsAppClick = (number, department) => {
    const message = `Hello Worldwide Corporation ${department} team! I would like to get in touch.`;
    const whatsappUrl = `https://wa.me/${number}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
    setOpen(false);
  };

  return (
    <>
      <FloatingButton
        onClick={() => setOpen(true)}
        aria-label="whatsapp-support"
        size="large"
      >
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 30 }}>
          <WhatsAppIcon />
        </Box>
      </FloatingButton>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 4,
            background: 'rgba(10, 14, 26, 0.95)',
            backdropFilter: 'blur(30px)',
            border: '1px solid rgba(255,255,255,0.06)',
            boxShadow: '0 25px 80px rgba(0,0,0,0.8)',
            overflow: 'hidden',
          }
        }}
      >
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderBottom: '1px solid rgba(255,255,255,0.05)',
            py: 2.5,
            px: 3,
          }}
        >
          <Typography
            variant="h6"
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              gap: 1.5,
              color: '#ffffff',
              fontFamily: "'Georgia', serif",
              fontWeight: 'bold',
              fontSize: '1.1rem',
              letterSpacing: '0.5px',
            }}
          >
            <Box sx={{ color: '#25D366', display: 'flex', fontSize: 28 }}>
              <WhatsAppIcon />
            </Box>
            WhatsApp Support
          </Typography>
          <IconButton 
            onClick={() => setOpen(false)} 
            sx={{ 
              color: 'rgba(255,255,255,0.3)',
              '&:hover': {
                color: '#ffffff',
                backgroundColor: 'rgba(255,255,255,0.05)',
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent sx={{ py: 3, px: 3 }}>
          <Typography
            variant="body2"
            sx={{ 
              color: 'rgba(255,255,255,0.4)',
              mb: 3,
              letterSpacing: '0.5px',
              fontSize: '0.85rem',
            }}
          >
            Select a department to start a WhatsApp conversation with Worldwide Corporation:
          </Typography>

          <List sx={{ p: 0 }}>
            {departments.map((dept, index) => (
              <ListItem
                key={`${dept.name}-${index}`}
                button
                onClick={() => handleWhatsAppClick(dept.number, dept.name)}
                sx={{
                  mb: 1.5,
                  borderRadius: 2.5,
                  border: '1px solid rgba(255,255,255,0.05)',
                  transition: 'all 0.3s ease',
                  py: 1.5,
                  px: 2,
                  backgroundColor: 'rgba(255,255,255,0.02)',
                  '&:hover': {
                    backgroundColor: 'rgba(37, 211, 102, 0.08)',
                    borderColor: 'rgba(37, 211, 102, 0.2)',
                    transform: 'translateX(4px)',
                    boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                  },
                }}
              >
                <ListItemIcon sx={{ 
                  color: '#25D366', 
                  minWidth: 40,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}>
                  {dept.icon}
                </ListItemIcon>
                <Box sx={{ flex: 1 }}>
                  <ListItemText
                    primary={
                      <Typography sx={{ 
                        color: '#ffffff', 
                        fontWeight: 600,
                        fontSize: '0.85rem',
                        letterSpacing: '0.3px',
                      }}>
                        {dept.name}
                      </Typography>
                    }
                    secondary={
                      <Typography sx={{ 
                        color: 'rgba(255,255,255,0.35)', 
                        fontSize: '0.7rem',
                        letterSpacing: '0.3px',
                      }}>
                        {dept.description}
                      </Typography>
                    }
                  />
                </Box>
                <Box sx={{ 
                  color: '#25D366', 
                  display: 'flex',
                  opacity: 0.6,
                  transition: 'opacity 0.3s ease',
                  '&:hover': {
                    opacity: 1,
                  },
                }}>
                  <WhatsAppIcon />
                </Box>
              </ListItem>
            ))}
          </List>

          <Card sx={{ 
            mt: 3, 
            bgcolor: 'rgba(37, 211, 102, 0.04)',
            border: '1px solid rgba(37, 211, 102, 0.06)',
            borderRadius: 2.5,
          }}>
            <CardContent sx={{ py: 2.5, px: 3 }}>
              <Typography
                variant="body2"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1.5,
                  mb: 1.5,
                  color: '#25D366',
                  fontWeight: 600,
                  fontSize: '0.8rem',
                  letterSpacing: '0.5px',
                }}
              >
                <Box sx={{ color: '#25D366', display: 'flex', fontSize: 18 }}>
                  <WhatsAppIcon />
                </Box>
                Business Hours:
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.3)', mb: 0.5, fontSize: '0.75rem' }}>
                Monday - Friday: 9:00 AM - 6:00 PM
              </Typography>
              <Typography variant="body2" sx={{ color: 'rgba(255,255,255,0.3)', fontSize: '0.75rem' }}>
                Saturday: 10:00 AM - 2:00 PM
              </Typography>
            </CardContent>
          </Card>
        </DialogContent>

        <DialogActions sx={{ 
          p: 2.5, 
          px: 3,
          borderTop: '1px solid rgba(255,255,255,0.03)',
        }}>
          <Button 
            onClick={() => setOpen(false)}
            sx={{
              color: 'rgba(255,255,255,0.3)',
              fontSize: '0.75rem',
              letterSpacing: '1px',
              textTransform: 'uppercase',
              fontWeight: '500',
              '&:hover': {
                color: '#ffffff',
                background: 'rgba(255,255,255,0.05)',
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default WhatsAppWidget;